import { useLocation } from 'react-router-dom';

import useAuth from '../../hooks/useAuth';
import { PATH_PAGE } from '../../routes/paths';

const useManagerAccess = () => {
  const { hasManagerRole, env } = useAuth();
  const { pathname } = useLocation();

  const {
    settings: {
      man_access_list_resource: manAccessListResource,
      man_access_list_site: manAccessListSite,
      man_access_schedule_site: manAccessScheduleSite,
      man_access_services: manAccessServices
    }
  } = env;

  const {
    general: {
      resource: { root: rootAgent },
      site: { siteList, siteSheet, siteSchedule },
      services
    }
  } = PATH_PAGE;

  // * Manager access

  if (
    hasManagerRole &&
    ((!manAccessListResource && pathname.includes(rootAgent)) ||
      (!manAccessListSite && pathname.includes(siteList)) ||
      (!manAccessListSite && pathname.includes(siteSheet)) ||
      (!manAccessServices && pathname.includes(services)) ||
      (!manAccessScheduleSite && pathname.includes(siteSchedule)))
  ) {
    return false;
  }

  return true;
};

export default useManagerAccess;
